// :cow: Cosmose CONFIDENTIAL :iso:
import { Pipe, PipeTransform } from '@angular/core';
import { ClientsResponse } from '../../models/clients-response';

@Pipe({
  name: 'filterUserClients',
})
export class FilterUserClientsPipe implements PipeTransform {

  transform(ids: number[], clientsResponse: ClientsResponse): number[] {
    return ids.filter(id => clientsResponse.content.map(a => a.id).includes(id));
  }
}
